// CartContext.js
import { createContext, useContext, useState, useEffect } from "react";
import useAddToCart from "../hooks/useAddToCart";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const { addToUserCart } = useAddToCart();
    const [cart, setCart] = useState([]);

    // Load cart from local storage on initial render
    useEffect(() => {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCart(localCart);
    }, []);

    // Add item to cart
    const addToCart = (product, quantity, color, addInstallationPrice) => {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const item = { product, quantity, color, addInstallationPrice };
        const updatedCart = [...localCart, item];
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCart(updatedCart);
    };

    // Remove item from cart
    const removeFromCart = (productId) => {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = localCart.filter((item) => item.product.id !== productId);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCart(updatedCart);
    };

    const updateCartItemQuantity = (productId, quantity) => {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = localCart.map((item) =>
            item.product.id === productId ? { ...item, quantity } : item
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        setCart(updatedCart);
    };

    // Sync cart with server after login
    const syncCart = async (userId, accessToken) => {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        try {
            for (const item of localCart) {
                await addToUserCart({
                    userId,
                    accessToken,
                    productId: item.product.id,
                    quantity: item.quantity,
                    color: item.color,
                    addInstallationPrice: item.addInstallationPrice,
                });
            }
            localStorage.removeItem("cart");
            setCart([]);
        } catch (error) {
            console.error("Failed to sync cart with server:", error);
        }
    };

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, syncCart, updateCartItemQuantity }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);